import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";
import "../../../../styles/components/account/manageAccount/editPhone.scss";
import { setAlert } from "../../../../actions/alertActions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { updateAccountData } from "../../../../actions/accountActions";

class EditPhoneNumber extends Component {
  constructor(props) {
    super(props);

    this._mounted = false;

    this.state = {
      validated: false,

      currentPrefix: this.props.prefix,
      currentPhone: this.props.phone,

      newPrefix: "",
      newPhone: "",
      newPhoneIsValid: false,
      newPhoneIsTouched: false,

      confirmedPrefix: "",
      confirmedPhone: "",
      confirmedPhoneIsValid: false,
      confirmedPhoneIsTouched: false,
    };

    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handlePrefixChange = this.handlePrefixChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handlePhoneOnBlur = this.handlePhoneOnBlur.bind(this);
    this.validateAll = this.validateAll.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePrefixChange(value, name) {
    this.safeSetState({
      [name]: "+" + value,
    });
  }

  handlePhoneChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  isPhoneValid(phone) {
    const regexPhone = /\d{9,9}/gi;
    let isValid;

    if (phone.trim() !== "" && regexPhone.test(phone)) {
      isValid = true;
    } else {
      isValid = false;
    }

    return isValid;
  }

  handlePhoneOnBlur(e) {
    if (e.target.name === "newPhone") {
      this.safeSetState({ newPhoneIsTouched: true }, () => {
        if (this.isPhoneValid(this.state.newPhone)) {
          this.safeSetState({ newPhoneIsValid: true }, () => {
            if (
              this.state.newPhoneIsValid &&
              this.state.confirmedPhoneIsValid
            ) {
              this.validateAll();
            }
          });
        } else {
          this.safeSetState({ newPhoneIsValid: false });
        }
      });
    } else if (e.target.name === "confirmedPhone") {
      this.safeSetState({ confirmedPhoneIsTouched: true }, () => {
        if (this.isPhoneValid(this.state.confirmedPhone)) {
          this.safeSetState({ confirmedPhoneIsValid: true }, () => {
            if (
              this.state.newPhoneIsValid &&
              this.state.confirmedPhoneIsValid
            ) {
              this.validateAll();
            }
          });
        } else {
          this.safeSetState({ confirmedPhoneIsInvalid: false });
        }
      });
    }

    if (this.state.newPhoneIsValid && this.state.confirmedPhoneIsValid) {
      this.validateAll();
    }
  }

  validateAll(callback) {
    if (
      this.state.newPrefix === this.state.confirmedPrefix &&
      this.state.newPhone === this.state.confirmedPhone
    ) {
      this.safeSetState({ validated: true }, callback);
    } else {
      this.safeSetState({ validated: false }, callback);
    }
  }

  handleOnSubmit(e) {
    e.preventDefault();

    const form = $(e.target)[0];

    this.safeSetState(
      {
        newPhoneIsTouched: true,
        confirmedPhoneIsTouched: true,
      },
      this.validateAll(() => {
        if (this.state.validated && form.checkValidity() !== false) {
          const patch = {
            name: this.props.name,
            email: this.props.email,
            mobile: this.state.confirmedPhone,
            internationalPrefix: this.state.confirmedPrefix,
          };

          axios
            .patch(
              this.props.brand?.brandName === "EVIO"
                ? "/api/private/users/backOffice"
                : "/api/private/users",
              patch,
              {
                cancelToken: new CancelToken((c) => (this.cancel = c)),
              }
            )
            .then((res) => {
              if (res.status === 200) {
                this.props.setAlert(
                  this.props.brand?.brandName === "EVIO"
                    ? I18n.t(res.data.message)
                    : I18n.t(res.data.message.message),
                  "primary"
                );
                this.props.updateAccountData(
                  this.state.confirmedPrefix,
                  this.state.confirmedPhone
                );
                this.props.onHide();
              }
            })
            .catch((err) =>
              this.props.setAlert(I18n.t(err.response.data.message), "danger")
            );
        } else {
          this.props.setAlert(I18n.t("signUp_InvalidData"), "danger");
        }
      })
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  resetState() {
    this.safeSetState({
      validated: false,

      currentPrefix: this.props.prefix,
      currentPhone: this.props.phone,

      newPrefix: "",
      newPhone: "",
      newPhoneIsValid: false,
      newPhoneIsTouched: false,

      confirmedPrefix: "",
      confirmedPhone: "",
      confirmedPhoneIsValid: false,
      confirmedPhoneIsTouched: false,
    });
  }

  render() {
    return (
      <Modal
        id="editPhone"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Translate value="accountDetails_editPhone" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="edit-phone-form" noValidate onSubmit={this.handleOnSubmit}>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editAccount_prefixLabel" />
              </Form.Label>
              <Form.Control
                as={PhoneInput}
                autoFormat={false}
                country={this.props.country}
                countryCodeEditable={false}
                name="currentPrefix"
                inputProps={{
                  name: "currentPrefix",
                  required: true,
                  autoFocus: true,
                }}
                value={this.props.prefix}
                placeholder=""
                required
                disabled={true}
              />
            </Form.Group>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editPhone_currentPhone" />
              </Form.Label>
              <Form.Control
                type="number"
                name="phone"
                value={this.props.phone}
                disabled={true}
              />
            </Form.Group>

            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editAccount_prefixLabel" />
              </Form.Label>
              <Form.Control
                as={PhoneInput}
                autoFormat={false}
                country={this.props.country}
                countryCodeEditable={false}
                inputProps={{
                  name: "currentPrefix",
                  required: true,
                  autoFocus: true,
                }}
                placeholder={String.fromCodePoint(0x1f1fa, 0x1f1f8) + " + 1"}
                value={this.props.newPrefix}
                onChange={(value) =>
                  this.handlePrefixChange(value, "newPrefix")
                }
                required
                disabled={false}
              />
            </Form.Group>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editPhone_newPhone" />
              </Form.Label>
              <Form.Control
                type="text"
                maxLength="9"
                name="newPhone"
                value={this.state.newPhone}
                onChange={this.handlePhoneChange}
                onBlur={this.handlePhoneOnBlur}
                required
                disabled={false}
              />
              {!this.state.newPhoneIsValid && this.state.newPhoneIsTouched && (
                <p className="error-text">
                  <Translate value="editPhone_invalidPhone_error" />
                </p>
              )}
            </Form.Group>

            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editAccount_prefixLabel" />
              </Form.Label>
              <Form.Control
                as={PhoneInput}
                autoFormat={false}
                country={this.props.country}
                countryCodeEditable={false}
                inputProps={{
                  name: "confirmedPrefix",
                  required: true,
                  autoFocus: true,
                }}
                placeholder={String.fromCodePoint(0x1f1fa, 0x1f1f8) + " + 1"}
                value={this.props.confirmedPrefix}
                onChange={(value) =>
                  this.handlePrefixChange(value, "confirmedPrefix")
                }
                required
                disabled={false}
              />
            </Form.Group>
            <Form.Group className="info-field">
              <Form.Label>
                <Translate value="editPhone_confirmedPhone" />
              </Form.Label>
              <Form.Control
                type="text"
                maxLength="9"
                name="confirmedPhone"
                value={this.state.confirmedPhone}
                onChange={this.handlePhoneChange}
                onBlur={this.handlePhoneOnBlur}
                disabled={false}
                required
              />
              {!this.state.confirmedPhoneIsValid &&
                this.state.confirmedPhoneIsTouched && (
                  <p className="error-text">
                    <Translate value="editPhone_invalidPhone_error" />
                  </p>
                )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {!this.state.validated &&
            this.state.confirmedPhoneIsTouched &&
            this.state.newPhoneIsTouched && (
              <p className="error-text">
                <Translate value="editPhone_invalidPhone_generalError" />
              </p>
            )}
          <button type="submit" form="edit-phone-form">
            <Translate value="editPhone_save" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.language,
  account: state.account,
  accountData: state.account.accountData,
  preferences: state.account.preferences,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert, updateAccountData })(
  EditPhoneNumber
);
